// Region.js

import React from 'react';
import { Select } from 'antd';

const Region = ({ value, onChange }) => {
  const regions = [
    "Dakar", "Diourbel", "Fatick", "Kaolack", "Kolda", "Louga",
    "Matam", "St Louis", "Tambacounda", "Thiès", "Ziguinchor",
    "Kaffrine", "Kédougou", "Sédhiou"
  ];

  return (
    <Select
    showSearch
    style={{ width: "100%" }}
  
    optionFilterProp="children"
  
    filterOption={(input, option) =>
      option?.children.toLowerCase().includes(input.toLowerCase())
    }
    value={value}  onChange={onChange}>
      {regions.map(region => (
        <Select.Option key={region} value={region}>
          {region}
        </Select.Option>
      ))}
    </Select>
  );
};

export default Region;
